
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/about-us",
      function () {
        return require("private-next-pages/about/about-us/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/about-us"])
      });
    }
  